"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionRequirementResultMetadataSchema = exports.ComponentFunctionRequirementInstanceMetadataSchema = exports.componentFunctionRequirementResultTypeName = exports.ComponentFunctionValidationResultKey = exports.ComponentFunctionValidationRequirementTypeId = void 0;
const zod_1 = require("zod");
const IInsightError_1 = require("../../IInsightError");
exports.ComponentFunctionValidationRequirementTypeId = 'ComponentFunction';
exports.ComponentFunctionValidationResultKey = 'ComponentFunctionValidationResult';
exports.componentFunctionRequirementResultTypeName = 'ComponentFunctionResult';
exports.ComponentFunctionRequirementInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.ComponentFunctionValidationResultKey),
    moduleName: zod_1.z.string().optional(),
    componentFunctionId: zod_1.z.string(),
});
exports.ComponentFunctionRequirementResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.componentFunctionRequirementResultTypeName),
    insights: zod_1.z.lazy(() => IInsightError_1.IInsightErrorSchema).array(),
});
//# sourceMappingURL=ComponentFunctionRequirementInstanceMetadata.js.map